import { Link } from "react-router-dom";
import { TuitionRequestInterface } from "../../../../interfaces/tuitionRequest.interface";
import { ParentShadowWalletInterface } from "../../../../interfaces/parent-shadow-wallet.interface";
import CoinsDisplay from "../../CoinsDisplay";

const ApprovedRequestDetails = ({
  tuitionRequest,
  wallet,
}: {
  tuitionRequest: TuitionRequestInterface;
  wallet?: ParentShadowWalletInterface | null;
}) => {
  return (
    <div className="flex flex-col gap-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Teacher Details */}
        <div className="mb-4 p-4 border rounded-lg shadow-sm bg-white">
          <div className="mb-2">
            <strong className="text-xl text-yellow-500">
              Assigned Teacher:
            </strong>
          </div>
          <div className="text-gray-800 font-medium space-y-3">
            <div className="flex flex-col space-y-2">
              <div className="text-lg font-semibold">
                {tuitionRequest?.preferredTeacher?.name || "Not Assigned"}
              </div>
              <div className="text-sm text-gray-600">
                {tuitionRequest?.preferredTeacher?.gender ||
                  "Gender not specified"}
              </div>
              <div className="text-sm text-gray-600">
                {tuitionRequest?.preferredTeacher?.phoneNumber ||
                  "Not Available"}{" "}
                -{" "}
                {tuitionRequest?.preferredTeacher?.address?.city ||
                  "No address"}
              </div>
              <div className="text-sm text-gray-600">
                {tuitionRequest?.preferredTeacher?.email ||
                  "Email not available"}
              </div>
              <div className="text-sm text-gray-600">
                {tuitionRequest?.preferredTeacher?.highestQualification
                  ?.degreeName || "Qualification not available"}
              </div>
              <div className="text-sm text-gray-600">
                {tuitionRequest?.preferredTeacher?.yearOfExperience
                  ? `${tuitionRequest?.preferredTeacher?.yearOfExperience} years of experience`
                  : "Experience not specified"}
              </div>
              <Link
                to={`/teacher/${tuitionRequest?.preferredTeacher?._id}`}
                className="inline-block mt-4 px-4 py-2 bg-yellow-500 text-white rounded-md hover:bg-yellow-400"
              >
                View Teacher's Details
              </Link>
            </div>
          </div>
        </div>

        {/* Parent and Student Details */}
        <div className="mb-4 p-4 border rounded-lg shadow-sm bg-white">
          <div className="flex flex-col space-y-2">
            <div className="flex items-center space-x-2">
              <strong className="text-yellow-500">Parent:</strong>
              <span className="text-gray-800 font-medium">
                {tuitionRequest?.parent?.name || "Not Specified"}
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <strong className="text-yellow-500">Student:</strong>
              <span className="text-gray-800 font-medium">
                {tuitionRequest?.student?.name || "Not Specified"}
              </span>
            </div>
          </div>
        </div>

        {/* Tuition Period */}
        <div className="mb-4 p-4 border rounded-lg shadow-sm bg-white">
          <div className="mb-2">
            <strong className="text-xl text-yellow-500">Tuition Period:</strong>
          </div>
          <div className="flex flex-col space-y-2">
            <div className="flex items-center space-x-2">
              <strong className="text-yellow-500">
                Total Number of Classes:
              </strong>
              <span className="text-gray-800 font-medium">
                <CoinsDisplay
                  value={
                    wallet?.totalNumberOfClasses ??
                    tuitionRequest?.requiredNumberOfClasses
                  }
                />
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <strong className="text-yellow-500">GC / Class:</strong>
              <span className="text-gray-800 font-medium">
                <CoinsDisplay value={wallet?.gcChargePerClass} />
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <strong className="text-yellow-500">Total GC Allocated:</strong>
              <span className="text-gray-800 font-medium">
                <CoinsDisplay value={wallet?.totalCoinsAllocated} />
              </span>
            </div>
           
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default ApprovedRequestDetails;
